import { useEffect, useState } from 'react';
import { ApiService } from '../../../js/ApiService';
import useClient from '../useClient/useClient';
import useEnvSite from '../useEnvSite/useEnvSite';

const getChannelAndUrl = (client, site, env) => {
  const isMobile = client && client.toLowerCase().includes('mobile');
  const platform = isMobile ? 'App' : 'Web';
  const brand = site === 'jdsports' ? 'JDSports' : 'FNL';
  const channel = brand + ' ' + platform;
  const siteEnv = env && env !== 'www' ? env + '.' : '';
  const bffUrl = 'https://' + siteEnv + 'api.' + site + '.com/graphql';
  return { channel, bffUrl };
};

function useFeatureFlag(category, name) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  const [flagValue, setFlagValue] = useState(null);
  const [flagData, setFlagData] = useState(null);

  const { site, env } = useEnvSite();
  const client = useClient();

  useEffect(() => {
    if (!category || !name) {
      setLoading(false);
      return;
    }

    const { channel, bffUrl } = getChannelAndUrl(client, site, env);

    let isMounted = true;
    setLoading(true);

    ApiService.getLoyaltyFlagsConfig(channel, bffUrl)
      .then(res => {
        if (!res.ok) {
          throw new Error(`Failed to fetch feature flag: ${res.statusText}`);
        }
        return res.json();
      })
      .then(json => {
        if (isMounted) {
          const config = json?.data?.getLoyaltyFlagsConfig;
          setFlagData(config);

          if (config && config.enabledFor) {
            const foundFlag = config.enabledFor.find(
              item => item.category === category && item.name === name
            );
            setFlagValue(foundFlag?.value ?? null);
            setIsEnabled(foundFlag?.value === 'true' || foundFlag?.value === true);
          } else {
            setFlagValue(null);
            setIsEnabled(false);
          }
          setError(null);
          setLoading(false);
        }
      })
      .catch(err => {
        if (isMounted) {
          setError(err);
          setFlagValue(null);
          setIsEnabled(false);
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [category, name, site, env, client]);

  return { loading, error, isEnabled, flagValue, flagData };
}

export default useFeatureFlag;
